import axios from "@lib/axios";

export async function getNextInvoiceSubscriptionAmount() {
  try {
    const res = await axios.get("users/next_invoice_subscriptions");

    return res.data.data;
  } catch (error) {
    return {
      next_invoice_subscription_amount: null,
      current_coupon: null,
    };
  }
}
